var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"x12":"","hidden-xs-only":"","text-md-right":""}},[_c('select-category',{attrs:{"types":_vm.types,"category":_vm.category},on:{"type":_vm.changeCategory}})],1)],1),_c('moments-infinite',{key:_vm.category,attrs:{"category":_vm.category}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }